import React from "react";
import { useSelector } from "react-redux";
import { Avatar, Popover } from "antd";
import { useIntl } from "react-intl";
import UserMenu from "../../components/UserInfo/UserMenu";
import sessionCompany, { COMPANY_SET, COMPANY_NONE } from "../../util/sessionCompany";

const UserProfile = () => {
  const user = useSelector(({ user }) => user);
  const show = user.show || {};
  const { confAuthorize } = window.appConfig;
  const intl = useIntl();

  if (!confAuthorize) return null;

  // Организация приходит из сессии, а не из конфигурации: зашитое умолчание
  // `appConfig.company` убрано — оно показывало имя нашей фирмы как организацию
  // пользователя (T036). Состояний три, и до входа мы молчим: «организация
  // не определена» и «сессии ещё нет» — разные ответы.
  const { status, title } = sessionCompany(user);
  const companyTitle =
    status === COMPANY_SET
      ? title
      : status === COMPANY_NONE
      ? intl.formatMessage({ id: "userprofile.company.unknown" })
      : "";

  return (
    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
      <Popover placement="bottomRight" content={<UserMenu />} trigger="click">
        <div className="gx-profile-avatar">
          {show.picture && (
            <Avatar
              src={show.picture}
              className="gx-size-40 gx-pointer gx-mr-3"
              alt=""
            />
          )}
          {!show.picture && (
            <Avatar className="gx-size-40 gx-pointer gx-mr-3">
              {show.literal}
            </Avatar>
          )}

          <span className="gx-avatar-name">
            {show.hello}

            <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" />
            <div className="gx-avatar-title">{companyTitle}</div>
          </span>
        </div>
      </Popover>
    </div>
  );
};

export default UserProfile;
